<template>
	<v-list class="pa-0">
		<template v-if="showMenu">
			<v-menu>
				<template #activator="{on}">
					<v-list-item class="layoutTile layoutTile--user layoutTile-user"
								 ripple
								 v-on="on">
						<v-list-item-content>
							<v-list-item-title class="text-uppercase text-center text-body-2 font-weight-bold">{{ label }}</v-list-item-title>
						</v-list-item-content>
						<v-icon>arrow_drop_down</v-icon>
					</v-list-item>
				</template>
				<slot name="menu"></slot>
			</v-menu>
		</template>
		<template v-else>
			<v-list-item class="layoutTile layoutTile--user py-2">
				<v-list-item-content>
					<v-list-item-title class="text-uppercase text-center text-body-2 font-weight-bold">{{ label }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</template>
		<v-divider></v-divider>
		<slot></slot>
	</v-list>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class LayoutNav extends Vue {
	@Prop() label: string;

	get showMenu() {
		return !!this.$slots.menu;
	}
}
</script>